const BOOLEAN_FIELDS = new Set(['profile_retention', 'audit_log_retention'])

const FIELD_LABEL_KEYS = Object.freeze({
  profile_retention: 'RetentionAuditLog_Section_ProfileRetention',
  uncontactable_web_devices_retention_period:
    'RetentionAuditLog_Label_WebDevicesRetention',
  uncontactable_anonymous_profiles_retention_period:
    'RetentionAuditLog_Label_AnonymousProfileRetention',
  uncontactable_identified_profiles_retention_period:
    'RetentionAuditLog_Label_IdentifiedProfileRetention',
  audit_log_retention: 'RetentionAuditLog_Section_AuditLogRetention',
  profile_auditlog_retention_period_months:
    'RetentionAuditLog_Label_ProfileAuditLogRetention',
  campaign_auditlog_retention_period_months:
    'RetentionAuditLog_Label_CampaignAuditLogRetention'
})

const SECTION_LABEL_KEYS = Object.freeze({
  0: 'RetentionAuditLog_Section_ProfileRetention',
  1: 'RetentionAuditLog_Section_AuditLogRetention'
})

const FIELD_UNIT_KEYS = Object.freeze({
  uncontactable_web_devices_retention_period: 'RetentionAuditLog_Unit_Days',
  uncontactable_anonymous_profiles_retention_period:
    'RetentionAuditLog_Unit_Days',
  uncontactable_identified_profiles_retention_period:
    'RetentionAuditLog_Unit_Days',
  profile_auditlog_retention_period_months: 'RetentionAuditLog_Unit_Months',
  campaign_auditlog_retention_period_months: 'RetentionAuditLog_Unit_Months'
})

export { BOOLEAN_FIELDS, FIELD_LABEL_KEYS, SECTION_LABEL_KEYS, FIELD_UNIT_KEYS }



// WEBPACK FOOTER //
// ./src/modules/settings/enum/RetentionAuditLogLabels.js